'use strict';

/** @type {import('.')} */
module.exports = Object;



//////////////////
// WEBPACK FOOTER
// ./~/es-object-atoms/index.js
// module id = 534
// module chunks = 12